import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'

const GuideList = ({ step, intl }) => {
  const guideMessages = [
    `1.) ${intl.formatMessage(messages.step1)}`,
    `2.) ${intl.formatMessage(messages.step2)}`,
    `3.) ${intl.formatMessage(messages.step3)}`,
  ]

  return (
    <div className="guide-list">
      {
        guideMessages.map((msg, index) => (
          <div key={index} className="guide-list-item">
            <p className={index < step ? 'fullfilled-step' : 'unfullfilled-step'}>
              {msg}
            </p>
            {
              index < step &&
              <img src="/assets/icons/sign-check-icon.png" alt="Checkmark" />
            }
          </div>
        ))
      }
    </div>
  )
}

GuideList.defaultProps = {
  step: 1,
}

GuideList.propTypes = {
  intl: PropTypes.object.isRequired,
  step: PropTypes.number,
}

const enhance = compose(
  connect(() => ({ }), { }),
  injectIntl,
)

export default enhance(GuideList)

const messages = defineMessages({
  step1: {
    id: 'guide.list.step1',
    defaultMessage: 'Vytvoriť účet',
  },
  step2: {
    id: 'guide.list.step2',
    defaultMessage: 'Vytvoriť test',
  },
  step3: {
    id: 'guide.list.step3',
    defaultMessage: 'Vyplnenie testu žiakmi',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/GuideList.js